(function (window) {
    "use strict";
    window.arsluna = window.arsluna || {};
    window.arsluna.ecommerce = window.arsluna.ecommerce || {};
    window.arsluna.widget = window.arsluna.widget || {};
})(window);

